<div *ngIf="!isUserProfileExpiryDatesUpdated && !isSearch" class="alert alert-warning alert-dismissible fade show" role="alert">
  <strong>Action Required: The passport or residency permits linked with this profile or its dependents, have expired. Please update your profile with the renewed dates as soon as possible.</strong> 
</div>
<div class="comments" *ngIf="showAppRej" (click)="openComments()">
    <img src="design/images/comment.png" />
</div>
<!-- <div *ngIf="showAppRej || isSearch" class="row banner task-amend">
    <div class="col">
        <h6 class="pt-5px"><strong>Profile management</strong> {{ employeeInfo }}</h6>
    </div>
    <div class="">
        <button (click)="showHistory()" *ngIf="isSearch && country!='All'" class="btn btn-secondary btn-sm bg-white"
            title="Profile History">
            <img src="design/images/history.png" />
        </button>
    </div>
</div> -->
<div *ngIf="showAppRej || isSearch"
     class="row banner task-amend align-items-center flex-nowrap gx-2 overflow-auto">
    <!-- Left Section: Profile Management Text -->
    <div class="col">
        <h6 class="pt-5px mb-0">
            <strong>Profile management</strong> {{ employeeInfo }}
        </h6>
    </div>
    <!-- Right Section: Profile History Button -->
    <div class="col-auto">
        <button (click)="showHistory()"
                *ngIf="isSearch && country!='All'"
                class="btn btn-secondary btn-sm bg-white d-inline-flex align-items-center gap-1"
                title="Profile History">
            <img src="design/images/history.png" alt="History" style="max-height:16px; width:auto;" />
            
        </button>
    </div>
</div>

<div *ngIf="noProfile" class="alert alert-warning alert-dismissible fade show" role="alert">
    <strong>Profile Not Found!</strong> You have not either created a profile or your profile create request is pending.
 
    <button type="button" (click)="closeDelegateWarning()" class="btn-close" aria-label="Close"></button>

</div>
<div *ngIf="!isSearch && this.isEdit && !noProfile" class="alert alert-danger alert-dismissible fade show "
    role="alert">
    <strong> Please note that your profile updates are still in draft status and will not reflect in any reports. Kindly
        acknowledge changes and click on submit on the 2nd tab for changes to be updated!
    </strong>
</div>


<div *ngIf="!showDefaultHeader" class="modal-header">
    <p class="modal-title h4 mt-3" id="title"><strong>Profile</strong></p>
    <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>
</div>

<div class="d-flex justify-content-between">
    <div *ngIf="isSearch" class="adj-mar-left">
        <button [ngClass]="{'btn-success': showActive, 'btn-danger':!showActive }"
            class="btn adjust-scale ">{{ActOrInact}}</button>
    </div>


    <div *ngIf="isSearch && showActive && country!='All' && !immUserProfileView" class="adj-mar-right">
        <button class="btn btn-secondary" (click)="openMail()">Send profile update reminder</button>
    </div>
</div>


<div class="proces">
    <div class="line"></div>
    <ul class="nav d-flex justify-content-between">
        <li>
            <a data-toggle="tab" class="cursor-pointer" [class.active]="activeTabIdx==0" (click)="showTab(0)">
                <div class="icon">
                    <img src="design/images/file.png" />
                </div>
            </a>
        </li>
        <li [class.disabled]="!canUploadDocuments">
            <a data-toggle="tab" class="cursor-pointer" [class.active]="activeTabIdx == 1" (click)="showTab(1)">
                <div class="icon">
                    <img src="design/images/fileup.png" />
                </div>
            </a>
        </li>
    </ul>
    <div class="tab-content mt-5">
        <!-- <div class="container-fluid mt-2"> -->
        <!-- <p *ngIf="showDefaultHeader" class="h4 mt-3">Profile</p> -->
        <!-- <div class="container mt-3"> -->
        <div class="tab-pane fade" [ngClass]="{'active show':activeTabIdx==0}" id="tab{{activeTabIdx}}">
            <div *ngFor="let step of userFields; let index = index; let first = first;">
                <formly-form [form]="formArray.at(index)" [fields]="step.fields" [model]="model"></formly-form>
            </div>
            <div class="row mt-4 mb-3">
                <div class="col-12 mt-4 text-center mb-3">
                     <button class="btn btn-outline-primary me-2" *ngIf="!isSearch && !immUserProfileView && hasDraftProfile"
                       (click)="deactivateDraft()">
                        Discard Draft
                    </button>
                    <button class="btn btn-outline-primary me-2" (click)="close()">
                        Close
                    </button>        
                    <button [disabled]="!formArray.dirty" eosDebounce *ngIf="!isSearch && !immUserProfileView"
                        title="You can save and come back to finish submission later"
                        class="btn btn-outline-primary me-2" (debounceClick)="saveContinue(false)">
                        Save
                    </button>
                    <button [disabled]="!formArray.dirty" eosDebounce class="btn btn-secondary me-2" *ngIf="!isSearch && !immUserProfileView"
                        (debounceClick)="saveContinue(true)">
                        Save and continue
                    </button>
                    <button [disabled]="!formArray.dirty" *ngIf="isSearch && showActive && !immUserProfileView" eosDebounce
                        class="btn btn-outline-primary me-2" (debounceClick)="saveProfile(false)">
                        Save profile
                    </button>
                    <button [disabled]="!formArray.dirty" *ngIf="isSearch && showActive && !immUserProfileView" eosDebounce
                        class="btn btn-outline-primary me-2" (debounceClick)="saveProfile(true)">
                        Save and continue
                    </button>
                </div>
            </div>
        </div>

        <div class="tab-pane fade" [ngClass]="{'active show':activeTabIdx == 1}" id="tab{{activeTabIdx}}">
            <eos-employee-file-upload (update)="fetchData()" [isEdit]="isEdit" [candidateForm]="formArray"
                [readonly]="fileUploadReadonly" [employeeProfile]="model" [isSearch]="isSearch"
                (validDocuments)="setValidDocuments($event)" (GetDocumentEvent)="GetDocuments($event)" (activeTabIdxEvent)="GetActiveTabIndex($event)">
            </eos-employee-file-upload>
            <div *ngIf="!showAppRej && !isSearch && !immUserProfileView" class="col-12 mt-4 mb-3">
                <input [(ngModel)]="profileConfirmed" type="checkbox"> By clicking on
                "Submit" I confirm that I have reviewed and updated my personal data on TMT and I acknowledge that it is
                my responsibility to ensure my employee details are captured accurately.
            </div>
            <div *ngIf="country=='All' && isSearch && !immUserProfileView" class="col-12 mt-4 mb-3">
                <input [(ngModel)]="profileConfirmed" type="checkbox"> By clicking on
                "Submit" I confirm that I have reviewed and updated data on TMT and I acknowledge that it is
                my responsibility to ensure the employee details are captured accurately.
            </div>
            <div class="col-12 mt-4 text-center mb-3">
                <button class="btn btn-outline-primary me-2" (click)="close()">
                    Close
                </button>
                <button *ngIf="!showAppRej && !isSearch && !immUserProfileView" eosDebounce class="btn btn-secondary me-2"
                    (debounceClick)="submit()" [disabled]="!profileConfirmed" type="submit">
                    Submit
                </button>
                <button *ngIf="isSearch && showActive && !immUserProfileView" eosDebounce class="btn btn-secondary me-2"
                    (debounceClick)="submitProfile()" [disabled]="!profileConfirmed && country=='All'" type="submit">
                    Submit
                </button>
                <button eosDebounce class="btn btn-outline-primary me-2" *ngIf="canAccDec  && showAppRej && !isSearch && !immUserProfileView"
                    (debounceClick)="rejectProfile()">
                    Reject
                </button>
                <button eosDebounce class="btn btn-secondary me-2" *ngIf="canAccDec  && showAppRej && !isSearch && !immUserProfileView"
                    (debounceClick)="approveProfile()">
                    Approve
                </button>
            </div>
        </div>
        <!-- </div> -->
        <!-- </div> -->
    </div>
</div>
